<template>
    <div class="container">
        <div class="col-md-12">
            <h2> {{ labels.title }} </h2> 
        </div>
        <div class="col-md-11 d-flex justify-content-end">
            <b-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="createMoneda">
                <i class="fa-solid fa-plus"></i>
            </b-button>
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-if="listMoneda.length > 0">
            <div class="col-md-11">
                <b-table
                    :items="listMoneda"
                    :fields="fields"
                    hover
                    bordered
                    responsive
                    small
                    class="tblEstandar"
                    head-variant="custom-blue"
                    @row-clicked="(item) => editMoneda(item.id)"
                >
                    <template #cell(moneda)="data">
                        <div class="text-left">{{ nameMoneda(data.item?.moneda) }}</div>
                    </template>
                    <template #cell(vigencia)="data">
                        <div class="text-left">{{ data.item?.vigencia }}</div>
                    </template>
                    <template #cell(trm)="data">
                        <div class="text-right">{{ data.item?.trm }}</div>
                    </template>
                    <template #cell(trm_promedio)="data">
                        <div class="text-right">{{ data.item?.trm_promedio }}</div>
                    </template>
                    <template #cell(valor_propio)="data">
                        <div class="text-right">{{ data.item?.valor_propio }}</div>
                    </template>
                </b-table>
                <div class="row col-md-12 align-items-center mt-1">
                    <div class="col-md-10 d-flex justify-content-center">
                        <b-pagination
                            :items="currentPage"
                            :total-rows="listMoneda.length"
                            align="center"
                            size="md"
                            class="custom-pagination"
                        ></b-pagination>
                    </div>
                    <div class="col-md-2 d-flex justify-content-end">
                        <label class="mr-2 mb-0">Filas por página:</label>
                        <b-form-select
                            :items="perPage"
                            :options="[5, 10, 20, 50, 100, 500]"
                            size="sm"
                            style="width: 80px;"
                        ></b-form-select>
                    </div>
                </div>
            </div>
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-else>
            <h5>{{ labels.noRow }}</h5> 
        </div>
        <Crear :modCrearMoneda="showCrearMoneda" @cierraModal="closeModal"></Crear>
        <Editar :modEditarMoneda="showEditarMoneda" :infoMoneda="dataMoneda" @cierraModal="closeModal"></Editar>
    </div>
</template>

<script>
import Moneda from '../../../services/Moneda'; 
import TipoMoneda from '../../../services/TipoMoneda'; 
import Crear from './Crear.vue'; 
import Editar from './Editar.vue'; 

export default {
    name : 'Moneda',
    components: {Crear,Editar},
    data : () => ({
        listMoneda : [],
        lstTipoMoneda : [],
        showCrearMoneda : false,
        showEditarMoneda : false,
        dataMoneda : [],
        perPage: 10,
        currentPage: 1,
        fields: [
            { key: 'moneda', label: 'Moneda', sortable: false },
            { key: 'vigencia', label: 'Vigencia', sortable: false },
            { key: 'trm', label: 'TRM', sortable: false },
            { key: 'trm_promedio', label: 'TRM promedio', sortable: false },
            { key: 'valor_propio', label: 'Valor propio', sortable: false }
        ],
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Moneda',
                    noRow : "No hay registros",
                    moneda : 'Moneda',
                    vigencia : 'Vigencia',
                    trm : 'TRM',
                    trmPromedio : 'TRM promedio',
                    valorPropio : 'Valor propio'
                }
            }else{
                return {
                    title : 'Currency',
                    noRow : "There are not records",
                    moneda : 'Currency',
                    vigencia : 'Validity',
                    trm : 'TRM',
                    trmPromedio : 'Average trm',
                    valorPropio : 'Self value'
                }
            }
        }
    },
    methods:{
        createMoneda(){
            this.showCrearMoneda = true 
        },
        editMoneda(id){
            Moneda.getMonedaById(id) 
            .then((res) => { 
                this.dataMoneda = res.data.infoMoneda[0] 
                this.showEditarMoneda = true 
            })
            .catch((err) => console.log(err)) 
        },
        closeModal(val){
            this.showCrearMoneda = val 
            this.showEditarMoneda = val 
        },
        nameMoneda(moneda){
            let nombre = this.lstTipoMoneda.find((tipMoneda) => tipMoneda.moneda === moneda) 
            return nombre?.descripcion 
        }
    },
    mounted(){
        Moneda.getAllMonedas() 
        .then((res) => { 
            // console.log(res.data.listMoneda); 
            const data = res.data.listMoneda 
            this.listMoneda = Array.isArray(data) ? data : (data && typeof data === 'object' ? Object.values(data) : []) 
        })
        .catch((error) => console.log(error)) 

        TipoMoneda.getAllTipoMoneda() 
        .then((res) => { 
            // console.log(res.data); 
            const data = res.data.listTipoMoneda 
            this.lstTipoMoneda = Array.isArray(data) ? data : (data && typeof data === 'object' ? Object.values(data) : []) 
        })
        .catch((err) => console.log(err)) 
    }
}
</script>

<style>

</style>
